
{
  "input-labels": {
    "title": "Title",
    "description": "Description",
    "images": "Gallery Images",
    "image-cropper": "Gallery Image"
  }
}
